<template>
  <div class='style-jiuhong'>
    <header-box :showSearch="false"></header-box>
    <div>
        <div style="width:1278px;margin:0 auto;min-height: 620px;">
            <div class="flex" style="margin:20px 0;width:710px;height:44px;">
                <el-input placeholder="请输入内容" v-model="myKeyword"></el-input>
                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </div>
            <div style="padding-bottom:20px;">
                <template v-if="dataList.length > 0">
                    <div @click="gotoDetail(item)" class="flex align-center cursor-pointer" style="padding: 15px 0;" v-for="(item, index) in dataList" :key="index">
                        <div class="point-red"></div>
                        <div style="flex:1;margin-left:20px;">
                            <span style="width:700px;display: inline-block;" class="elipsis-class">
                                {{item.title}}
                            </span>
                            <span style="float:right;">{{item.publishTime}}</span>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div style="text-align:center;padding:20;">
                        暂无数据
                    </div>
                </template>
                <el-pagination
                style="margin:20px 0;"
                layout='->, prev,pager,next,total,sizes,jumper'
                @size-change='changeSize'
                @current-change='changeCurrent'
                :page-size='pageData.pageSize'
                :page-sizes="['10','20','30','40','50']"
                :current-page='pageData.pageNumber'
                :pager-count='7'
                :total='total'></el-pagination>
            </div>
        </div>
    </div>
    <foot-box></foot-box>
  </div>
</template>

<script>
import headerBox from "../components/HeaderBox";
import footBox from "../components/FootBox";
export default {
    props: {
        keyword: {
            type: String,
            default: ''
        }
    },
    components: {
        headerBox,
        footBox
    },
    data() {
        return {
            total: 0,
            pageData: {
                pageSize: 10,
                pageNumber: 1
            },
            dataList: [],
            myKeyword: this.keyword
        }
    },
    methods: {
        handleSearch () {
            this.getDataList(this.myKeyword)
        },
        changeSize (value) {
            this.pageData.pageSize = value
            this.getDataList(this.myKeyword)
        },
        changeCurrent (value) {
            this.pageData.pageNumber = value
            this.getDataList(this.myKeyword)
        },
        getDataList (data) {
            const param = {
                pageSize: this.pageData.pageSize,
                pageNum: this.pageData.pageNumber,
                titleOrContent: data
            }
            this.$api.home.searchByKeyword(param).then(res => {
                console.log(res)
                if (res.code === 200) {
                    if (res.data.content.length > 0) {
                        res.data.content.forEach(item => {
                            item.publishTime = item.publishTime.split('T')[0]
                        })
                    }
                    this.dataList = res.data.content
                    this.total = res.data.totalElements
                }
            })
        },
        gotoDetail (item) {
            console.log(item)
            this.$router.push({
                name: 'noticeDetaile',
                params: {
                    noticeId: item.id,
                    id: item.category.parent ? item.category.parent.id : item.category.id
                }
            })
        }
    },
    mounted () {
        this.myKeyword = this.$route.params.keyword
        this.getDataList(this.$route.params.keyword)
    }
}
</script>

<style scoped lang='less'>
/deep/ .el-input__inner{
  border-radius: 0;
  height: 44px;
  background: #FFFFFF;
}
/deep/ .el-button{
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 0;
  padding: 12px 30px 12px 20px;
  background: #C81520;
}
/deep/ .el-button:focus, .el-button:hover {
  background: #C81520;
  color: #fff;
}
/deep/ .el-icon-search:before{
  color: #fff;
}
.point-red{
    border:4px solid #650004;
    border-radius:4px;
    width:0;
    height:0;
    background: #650004;
}
.elipsis-class{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.line-height-50 {
  width: 116.1818px;
  text-align: center;
  cursor: pointer;
  padding: 17px 0;
}
// ul li .border-right{
//     border-right: 1px solid #fff;
// }
// ul li:last-child .border-right{
//     border-right: none;
// }
.active-class {
  background: #c81520;
}
.active-class .border-right {
  border: none;
}
.date-class {
  width: 86px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #fff;
  margin-right: 10px;
  text-align: center;
}
.intro-new {
  overflow: hidden;
  font-size: 14px;
  line-height: 24px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
